import { type CandidateApplicationsResponse } from "../api";
import { Utility } from "./utility";

export interface CandidateApplication extends CandidateApplicationsResponse {}

export class CandidateApplication extends Utility<CandidateApplication> {
  constructor(init?: Partial<CandidateApplicationsResponse>) {
    super();
    Object.assign(this, init);
  }
}
